import { TenderStatus } from 'src/app/models/TenderStatus.class';
import { File } from 'src/app/models/File.class';

export class Tender{

  constructor(){
    this.Files=[];
  }

  TenderId?:number;
  Title?:string;
  MolsaTenderNumber?:string;
  MolsaTenderType?:number;
  MolsaTenderPublishDate?:string;
  MolsaTenderUpdate?:string;
  MolsaTenderQADate?:string;
  MolsaProposalHandingDate?:string;
  MolsaTenderStatus?:number;
  MolsaTenderInManof?:string;
  MolsaTenderPayment?:number;
  MolsaTenderEncryptedPayment?:string;
  MolsaTenderConventionLocation?:string;
  FullName?:string;
  EMail?:string;
  WorkPhone?:string;
  MolsaTenderConventionDate?:string;
  TenderUrl?:string;
  MolsaTenderMoreInfo?:string;

  Files:File[];
  TenderStatus?:TenderStatus;
}